import React, { useState, useEffect, useContext} from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
   Box,
   Container,
   Grid,
   
} from '@material-ui/core'

// components
import TotalFittings from '../components/dashboard/TotalFittings'
import TotalHoses from '../components/dashboard/TotalHoses'
import TotalSales from '../components/dashboard/TotalSales'
import TotalCustomers from '../components/dashboard/TotalCustomers'
import LatestOrders from '../components/dashboard/LatestOrders'
import Loader from '../components/utils/Loader'
import SearchResult from '../components/SearchResult'
// import LatestProducts from '../components/dashboard/LatestProducts'
// import Sales from '../components/dashboard/Sales'
// import TrafficByDevice from '../components/dashboard/TrafficByDevice'

// API
import { postPublicAPI} from '../api'
import { ToastContext } from '../contexts/Toast'
import { ShoppingCartContext } from '../contexts/ShoppingCart'


const Dashboard = () => {
   const navigate = useNavigate()
   // const { shopping, setShopping } = useContext(ShoppingCartContext)
   const [loading, setLoading] = useState(true)
   const { setToasts } = useContext(ToastContext)
   const location = useLocation()

   const {
      searchC,
     
   } = useContext(ShoppingCartContext)

   useEffect(() => {
      
      const checkStatus = async () => {
         if (localStorage.auth_token) {
            let user = localStorage.user_id
            let status = await postPublicAPI('/check-status', { user })

            if (status?.success) {
               const { userstatus } = status.data
               localStorage.setItem('user_status', userstatus)

               if (userstatus === 'Disabled') {
                  localStorage.clear()
                  navigate('/login', { replace: true })

                  setToasts({
                     type: 'error',
                     messages: [{ msg: 'Account Disabled' }]
                  })
               }
            }
         }
      }

      checkStatus()
      // setShopping(!shopping)
   }, [navigate, setToasts])

   useEffect(() => {
      let mounted = true

      setTimeout(() => {
         if (!localStorage.auth_token) navigate('/login')
         mounted && setLoading(false)
      }, 1000)

      return () => (mounted = false)
   }, [navigate])

   let adminType = localStorage.user_type !== 'customer' ? true : false
   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Dashboard | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               ) 
               : searchC ?
                     (
                        <SearchResult location={location} />
                     )
                         
                  :(<Grid container spacing={3}>
                     <Grid item lg={adminType ? 3 : 4} sm={6} xl={adminType ? 3 : 4} xs={12}>
                        <TotalFittings />
                     </Grid>
                     <Grid item lg={adminType ? 3 : 4} sm={6} xl={adminType ? 3 : 4} xs={12}>
                        <TotalHoses />
                     </Grid>
                     {adminType && (
                        <Grid item lg={3} sm={6} xl={3} xs={12}>
                           <TotalCustomers />
                        </Grid>
                     )}
                     <Grid item lg={adminType ? 3 : 4} sm={6} xl={adminType ? 3 : 4} xs={12}>
                        <TotalSales sx={{ height: '100%' }} />
                     </Grid>
                     {/* <Grid item lg={8} md={12} xl={9} xs={12}>
                        <Sales />
                     </Grid>
                     <Grid item lg={4} md={6} xl={3} xs={12}>
                        <TrafficByDevice sx={{ height: '100%' }} />
                     </Grid> */}
                     {/* <Grid item lg={4} md={6} xl={3} xs={12}>
                        <LatestProducts sx={{ height: '100%' }} />
                     </Grid> */}
                     {/* <Grid item lg={8} md={12} xl={9} xs={12}> */}
                     <Grid item lg={12} md={12} xl={12} xs={12}>
                        <LatestOrders />
                     </Grid>
                  </Grid>
               )}
            </Container>
         </Box>
      </>
   )
}

export default Dashboard
